import {
  ICitiesData,
  ITopTerritoriesEntity,
} from 'components/data-containers/KPIs/Discovery/types';

const useDiscoveryCityData = (
  citiesData: ICitiesData[]
): ITopTerritoriesEntity[] | undefined => {
  if (!citiesData) return;
  return citiesData.map(({ entity, cities: data }: any) => ({ entity, data }));
};

export default useDiscoveryCityData;
